import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { EmotionIconBase } from '@emotion-icons/emotion-icon';
export var Sparkle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(EmotionIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1063 8.38896L19.8963 6.80912L21.6463 6.09594C22.0363 5.93344 22.0363 5.43692 21.6463 5.27442L19.8963 4.56124L19.1063 2.97237C18.9263 2.62029 18.3763 2.62029 18.1963 2.97237L17.4063 4.55221L15.6463 5.26539C15.2563 5.42789 15.2563 5.92441 15.6463 6.08691L17.3963 6.80009L18.1863 8.38896C18.3663 8.74104 18.9263 8.74104 19.1063 8.38896ZM11.1463 9.74311L9.55628 6.58343C9.20628 5.87927 8.08628 5.87927 7.73628 6.58343L6.14628 9.74311L2.64628 11.1785C1.86628 11.5035 1.86628 12.5056 2.64628 12.8215L6.14628 14.2569L7.73628 17.4166C8.09628 18.1208 9.20628 18.1208 9.55628 17.4166L11.1463 14.2569L14.6463 12.8215C15.4263 12.4965 15.4263 11.4945 14.6463 11.1785L11.1463 9.74311ZM18.1863 15.6111L17.3963 17.1909L15.6463 17.9041C15.2563 18.0666 15.2563 18.5631 15.6463 18.7256L17.3963 19.4388L18.1863 21.0277C18.3663 21.3797 18.9163 21.3797 19.0963 21.0277L19.8863 19.4478L21.6463 18.7346C22.0363 18.5721 22.0363 18.0756 21.6463 17.9131L19.8963 17.1999L19.1063 15.6111C18.9263 15.259 18.3663 15.259 18.1863 15.6111Z",
    fill: "currentColor"
  }));
});
Sparkle.displayName = 'Sparkle';
export var SparkleDimensions = {
  height: 24,
  width: 24
};